import { gql } from "generated-graphql";

gql(`
fragment PipelineFragment on Pipeline {
    id
    name
    tenantId
    tenant {
      id
      name
    }
    lastRunAt
    createdAt
    createdBy
    updatedAt
    updatedBy
}
`);

export const STAFF_PIPELINE_DIALOG_QUERY = gql(`
    query StaffPipelineDialog($id: ID!) {
      pipeline(id: $id) {
        ...PipelineFragment
        inputFiles
        outputFiles
      }
    }
  `);

export const STAFF_PIPELINES_TABLE_QUERY = gql(`
    query StaffPipelinesTable($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
      pipelines(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
        items {
          ...PipelineFragment
        }
        count
      }
    }
  `);
